import { useEffect, useRef, useState } from 'react'

/**
 * Home owns the slide content; this component owns only the optional second
 * slot, native scroll-snap swipe state, and the two-dot pagination contract.
 */
export default function HomeHeroCarousel({ standardHero, academicHero }) {
  const trackRef = useRef(null)
  const [activeIndex, setActiveIndex] = useState(0)
  const hasAcademicHero = Boolean(academicHero)

  useEffect(() => {
    const track = trackRef.current
    if (!track || hasAcademicHero) return
    track.scrollLeft = 0
    setActiveIndex(0)
  }, [hasAcademicHero])

  const handleScroll = event => {
    const track = event.currentTarget
    if (!hasAcademicHero || !track.clientWidth) return
    setActiveIndex(Math.min(1, Math.max(0, Math.round(track.scrollLeft / track.clientWidth))))
  }

  if (!hasAcademicHero) return standardHero

  return (
    <section className="home-hero-carousel" aria-label="홈 히어로">
      <div ref={trackRef} className="home-hero-carousel__track" onScroll={handleScroll}>
        <div className="home-hero-carousel__slide" data-testid="home-hero-slide-standard">
          {standardHero}
        </div>
        <div className="home-hero-carousel__slide" data-testid="home-hero-slide-academic">
          {academicHero}
        </div>
      </div>
      <div className="home-hero-carousel__indicator" aria-label={`${activeIndex + 1} / 2 페이지`}>
        <span aria-hidden="true">{activeIndex === 0 ? '●' : '○'}</span>
        <span aria-hidden="true">{activeIndex === 1 ? '●' : '○'}</span>
      </div>
    </section>
  )
}
